<script>
    import Cinema from "../components/Cinema.svelte";
    import { onMount } from "svelte";
    import ajaxFetch from "../services/ajaxFetch";

    let {
        index,
        featureIndex,
        removeSkeleton,
        errorCallback,
        performance,
        cinemaInjectionContainerWidth = $bindable(),
        eventMergeId,
        targetElement,
    } = $props();

    let cinemaHasLoaded = $state(false);
    let headline = $state(),
        recommendations = $state(),
        tracking = $state(),
        additionalClickTracking = $state(),
        metaData = $state(),
        featuresState = $state(),
        hasPersonalisedRecommendations = $state();

    onMount(async () => {
        performance.cinemaLoadingStarted();
        attachParentVisibilityObserver(targetElement);
        const res = await ajaxFetch(`/reco-core/recommendations/emptybasket/`);
        removeSkeleton();
        if (res.status !== 200) {
            errorCallback();
            return;
        }
        ({
            headline,
            recommendations,
            tracking,
            additionalClickTracking,
            metaData,
            featuresState,
            hasPersonalisedRecommendations = false,
        } = await res.json());
        cinemaHasLoaded = true;
    });

    const attachParentVisibilityObserver = (targetElement) => {
        if (targetElement?.parentNode) {
            const parentObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    const isParentVisible = mutation.target.style.display !== "none";
                    if (isParentVisible) {
                        cinemaInjectionContainerWidth = targetElement.offsetWidth;
                    }
                });
            });
            parentObserver.observe(targetElement.parentNode, {
                attributes: true,
                attributeFilter: ["class"],
            });
        }
    };
</script>

{#key cinemaInjectionContainerWidth}
    {#if cinemaHasLoaded}
        <Cinema
            {headline}
            {recommendations}
            {tracking}
            {featureIndex}
            {additionalClickTracking}
            {featuresState}
            {cinemaInjectionContainerWidth}
            cinemaIndex={index}
            cinemaMeta={metaData}
            {performance}
            trackingEventMergeId={eventMergeId}
            loadedTrackingActionName="delete"
            site="reco_emptyBasket"
            personalisedUser={hasPersonalisedRecommendations}
        />
    {/if}
{/key}
